<div class="cabana-page">

  <section class="cabana-container">

    <div class="cabana-resumo">

      <div class="resumo-info">

        <h2>Cabana Ypê</h2>

        <p>
          Um refúgio confortável em meio à natureza,
          perfeito para descansar e viver momentos
          especiais no Paraíso do Cerrado.
        </p>

      </div>
    </div>

    <section class="galeria">

      <!-- Botão anterior -->
      <button
        type="button"
        class="galeria-btn galeria-btn-esquerda"
        (click)="imagemAnterior()"
        aria-label="Imagens anteriores"
      >
        ‹
      </button>


      <!-- Fotos -->
      <div class="galeria-fotos">

        <div
          class="galeria-foto"
          *ngFor="let imagem of imagensVisiveis"
        >

          <img
            [src]="imagem"
            alt="Cabana Ypê"
            loading="lazy"
          >

        </div>

      </div>


      <!-- Botão próxima -->
      <button
        type="button"
        class="galeria-btn galeria-btn-direita"
        (click)="proximaImagem()"
        aria-label="Próximas imagens"
      >
        ›
      </button>


      <!-- Indicadores -->
      <div class="galeria-indicadores">

        <button
          type="button"
          *ngFor="let pagina of [].constructor(totalPaginasGaleria); let i = index"
          [class.ativo]="i === paginaGaleriaAtual"
          (click)="selecionarImagem(i)"
          [attr.aria-label]="'Página ' + (i + 1) + ' da galeria'"
        ></button>

      </div>

    </section>

    <section class="conteudo-grid">

      <div class="conteudo-principal">

        <section class="texto-section">

          <h2>Conheça este espaço</h2>

          <p>
            A Cabana Ypê, do @paraisodocerradoo, é um refúgio romântico a apenas 60 km de Goiânia. Localizada em um condomínio de pequenas chácaras/ranchos (o mais próximo fica a 250m), oferece privacidade, segurança e contato com a natureza. Relaxe na hidro aquecida, aproveite a fogueira, o balanço e a ducha ao ar livre. O cenário perfeito para celebrar o amor, descansar e criar memórias.
          </p>
          <br>
          <p>
            Condições especiais para reservas de 2 dias!
          </p>
          <br>
          <p>
            <strong>O espaço</strong><br>
            A Cabana Ypê possui um banheiro espaçoso, um quarto/mesanino com cama de casal e com vista panorâmica para as montanhas, um quarto na parte inferior com cama de casal, jardim de inverno e uma sala integrada com cozinha.
          </p>
          <br>
          <p>
            <strong>Acesso do hóspede</strong><br>
            Os hospedes podem usam todo o espaço pois se trata de um local privativo.
          </p>

        </section>


        <section class="texto-section">

          <h2>O que há neste espaço?</h2>

          <div class="comodidades-grid">

            <!-- Banheiro -->
            <div>
              <strong>Banheiro</strong>

              <ul>
                <li>Banheira</li>
                <li>Secador de cabelo</li>
                <li>Chuveiro externo</li>
                <li>Água quente</li>
              </ul>
            </div>


            <!-- Quarto e lavanderia -->
            <div>
              <strong>Quarto e lavanderia</strong>

              <ul>
                <li>Cabides</li>
                <li>Cortinas blackout</li>
                <li>Ferro de passar</li>
              </ul>
            </div>


            <!-- Entretenimento -->
            <div>
              <strong>Entretenimento</strong>

              <ul>
                <li>Conexão Ethernet</li>
                <li>TV</li>
              </ul>
            </div>


            <!-- Família -->
            <div>
              <strong>Família</strong>

              <ul>
                <li>Jogos de tabuleiro</li>
              </ul>
            </div>


            <!-- Climatização -->
            <div>
              <strong>Climatização</strong>

              <ul>
                <li>Ar-condicionado</li>
              </ul>
            </div>


            <!-- Segurança doméstica -->
            <div>
              <strong>Segurança doméstica</strong>

              <ul>
                <li>
                  Câmeras de segurança na parte externa da propriedade
                </li>
              </ul>
            </div>


            <!-- Internet e escritório -->
            <div>
              <strong>Internet e escritório</strong>

              <ul>
                <li>Wi-Fi</li>
                <li>Espaço de trabalho exclusivo</li>
              </ul>
            </div>


            <!-- Cozinha e sala de jantar -->
            <div>
              <strong>Cozinha e sala de jantar</strong>

              <ul>
                <li>
                  Cozinha
                </li>

                <li>Micro-ondas</li>

                <li>
                  Pratos e talheres
                </li>

                <li>Frigobar</li>
                <li>Fogão</li>
                <li>Taças de vinho</li>
              </ul>
            </div>


            <!-- Características da localização -->
            <div>
              <strong>Características da localização</strong>

              <ul>
                <li>
                  Entrada privada
                </li>
              </ul>
            </div>


            <!-- Ar livre -->
            <div>
              <strong>Ar livre</strong>

              <ul>
                <li>Pátio ou varanda (Privativa)</li>

                <li>
                  Quintal privado — totalmente cercado
                </li>

                <li>Lareira externa</li>
                <li>Móveis na área externa</li>
                <li>Rede</li>
                <li>Churrasqueira</li>
                <li>Cadeira espreguiçadeira</li>
              </ul>
            </div>


            <!-- Estacionamento e instalações -->
            <div>
              <strong>Estacionamento e instalações</strong>

              <ul>
                <li>Estacionamento gratuito no local</li>
                <li>Banheira de hidromassagem</li>
              </ul>
            </div>


            <!-- Serviços -->
            <div>
              <strong>Serviços</strong>

              <ul>
                <li>
                  Permitido Pets
                </li>

                <li>
                  É permitido deixar as bagagens
                </li>

                <li>Permitido fumar</li>
                <li>Self check-in</li>
                <li>Cofre de chaves</li>
              </ul>
            </div>


            <!-- Não incluso -->
            <div>
              <strong>Não incluso</strong>

              <ul>
                <li>Indisponível: Máquina de lavar</li>
                <li>Indisponível: Secadora</li>
                <li>Indisponível: Café da manhã</li>

                <li>
                  Indisponível: Detector de fumaça
                </li>

                <li>
                  Indisponível: Detector de monóxido de carbono
                </li>

                <li>Indisponível: Aquecedor</li>
              </ul>
            </div>

          </div>

        </section>

      </div>

      <aside class="reserva-card">

        <div class="reserva-card-header">

          <div>

            <span>A partir de</span>

            <strong>
              R$
              {{ valorTotal | number:'1.2-2' }}
            </strong>

            <small>/ noite</small>

          </div>

        </div>

        <div class="campo-reserva">

          <label>Acomodação</label>

          <div class="campo-valor">

            <span>⌂</span>

            <strong>Cabana Ypê</strong>

          </div>

        </div>

        <div class="campo-reserva">

          <label>Check-in</label>

          <button
            type="button"
            class="campo-botao"
            (click)="abrirCalendario('entrada')"
          >

            <span>▣</span>

            {{
              dataEntrada
                ? formatarData(dataEntrada)
                : 'Selecione a data'
            }}

          </button>

        </div>


        <div class="campo-reserva">

          <label>Check-out</label>

          <button
            type="button"
            class="campo-botao"
            (click)="abrirCalendario('saida')"
          >

            <span>▣</span>

            {{
              dataSaida
                ? formatarData(dataSaida)
                : 'Selecione a data'
            }}

          </button>

        </div>

        <div class="horarios-reserva">
          <div>
            <strong>🕐 Check-in</strong>
            <span>A partir das 14:00</span>
          </div>

          <div>
            <strong>🕙 Check-out</strong>
            <span>Até as 11:00</span>
          </div>
        </div>

        <div class="campo-reserva">

          <label>Hóspedes</label>

          <button
            type="button"
            class="campo-botao"
            (click)="toggleHospedes()"
          >

            <span>♙</span>

            {{ totalHospedes }}
            {{ totalHospedes === 1 ? 'hóspede' : 'hóspedes' }}

          </button>


          <div
            class="hospedes-dropdown"
            *ngIf="mostrarHospedes"
          >

            <div class="hospede-linha">

              <div>

                <strong>Adultos</strong>

                <small>
                  12 anos ou mais
                </small>

              </div>

              <div class="contador">

                <button
                  type="button"
                  (click)="alterarHospedes('adultos', -1)"
                >
                  −
                </button>

                <span>
                  {{ adultos }}
                </span>

                <button
                  type="button"
                  (click)="alterarHospedes('adultos', 1)"
                >
                  +
                </button>

              </div>

            </div>


            <div class="hospede-linha">

              <div>

                <strong>Crianças</strong>

                <small>
                  De 2 a 11 anos
                </small>

              </div>

              <div class="contador">

                <button
                  type="button"
                  (click)="alterarHospedes('criancas', -1)"
                >
                  −
                </button>

                <span>
                  {{ criancas }}
                </span>

                <button
                  type="button"
                  (click)="alterarHospedes('criancas', 1)"
                >
                  +
                </button>

              </div>

            </div>


            <div class="hospede-linha">

              <div>
                <strong>Pets</strong>
                <small>Pets (máximo 2)</small>
              </div>

              <div class="contador">

                <button
                  type="button"
                  [disabled]="animais <= 0"
                  (click)="alterarHospedes('animais', -1)"
                >
                  −
                </button>

                <span>{{ animais }}</span>

                <button
                  type="button"
                  [disabled]="animais >= 2"
                  (click)="alterarHospedes('animais', 1)"
                >
                  +
                </button>

              </div>

            </div>

          </div>

        </div>


        <!-- Calendário de reservas -->
        <div class="calendario" *ngIf="mostrarCalendario">
          <div class="calendario-header">
            <button type="button" (click)="mesAnterior()" aria-label="Mês anterior">‹</button>
            <strong>{{ nomesMeses[mesAtual] }} {{ anoAtual }}</strong>
            <button type="button" (click)="mesProximo()" aria-label="Próximo mês">›</button>
          </div>
          <p class="calendario-mensagem" *ngIf="carregandoCalendario">Carregando disponibilidade e regras...</p>
          <p class="calendario-erro" *ngIf="erroCalendario">Não foi possível consultar as datas. Atualize a página para tentar novamente.</p>
          <div class="calendario-regra" *ngIf="!carregandoCalendario && !erroCalendario && dataEntrada && modoCalendario === 'saida'">
            <strong>Estadia mínima: {{ minimoNoitesSelecionado }} {{ minimoNoitesSelecionado === 1 ? 'noite' : 'noites' }}</strong>
            <span>Check-in: {{ formatarData(dataEntrada) }}</span>
            <span>Primeiro check-out permitido: {{ formatarData(checkoutMinimo) }}</span>
          </div>
          <div class="calendario-semana"><span>Dom</span><span>Seg</span><span>Ter</span><span>Qua</span><span>Qui</span><span>Sex</span><span>Sáb</span></div>
          <div class="calendario-dias">
            <button type="button" *ngFor="let dia of diasCalendario"
                    [class.vazio]="dia.numero === 0"
                    [class.hoje]="dia.hoje"
                    [class.selecionado]="dia.selecionado"
                    [class.intervalo]="dia.intervalo"
                    [class.dia-bloqueado]="dia.numero !== 0 && dia.desabilitado"
                    [class.dia-checkout-minimo]="modoCalendario === 'saida' && checkoutMinimo !== null && mesmaData(dia.data, checkoutMinimo) && !dia.desabilitado"
                    [class.dia-checkout-disponivel]="modoCalendario === 'saida' && checkoutMinimo !== null && dia.data > checkoutMinimo && !dia.desabilitado && !dia.selecionado && dia.numero !== 0"
                    [disabled]="dia.numero === 0 || dia.desabilitado"
                    (click)="selecionarData(dia)">
              <ng-container *ngIf="dia.numero !== 0">{{ dia.numero }}</ng-container>
            </button>
          </div>
          <div class="calendario-legenda" *ngIf="!carregandoCalendario && !erroCalendario && modoCalendario === 'saida' && dataEntrada">
            <span><i class="legenda-minimo"></i> Primeiro check-out permitido</span>
            <span><i class="legenda-disponivel"></i> Check-out disponível</span>
            <span><i class="legenda-bloqueado"></i> Indisponível</span>
          </div>
          <div class="calendario-footer"><span>{{ modoCalendario === 'entrada' ? 'Selecione o check-in' : 'Selecione o check-out' }}</span></div>
        </div>



        <div
          class="reserva-total"
          *ngIf="dataEntrada && dataSaida"
        >
          <div>
    <span>
      {{ quantidadeNoites }}
      {{ quantidadeNoites === 1 ? 'noite' : 'noites' }}
    </span>

            <strong>
              R$ {{ valorTotal | number:'1.2-2' }}
            </strong>
          </div>

          <p
            class="reserva-regra-atendida"
            *ngIf="minimoNoitesSelecionado > 1"
          >
            ✓ Estadia mínima de
            {{ minimoNoitesSelecionado }}
            noites atendida.
          </p>
        </div>



        <button
          type="button"
          class="btn-continuar"
          [disabled]="processando"
          (click)="continuarReserva()"
        >

          <span *ngIf="!processando">
            Continuar para pagamento
          </span>

          <span *ngIf="processando">
            Verificando disponibilidade...
          </span>

        </button>


        <p class="aviso-reserva">

          Você não será cobrado neste momento.
          A próxima etapa será o pagamento da reserva.

        </p>

      </aside>

    </section>

    <section class="avaliacao-section">

      <div class="avaliacao-nota">

        <ng-container *ngIf="avaliacoes.length > 0">

          <strong>
            {{ mediaAvaliacoes | number:'1.2-2' }}
          </strong>

          <span>
        ★★★★★
      </span>

          <small>
            {{ avaliacoes.length }}
            {{ avaliacoes.length === 1
            ? 'avaliação dos hóspedes'
            : 'avaliações dos hóspedes'
            }}
          </small>

        </ng-container>

        <ng-container *ngIf="avaliacoes.length === 0">

          <strong>
            —
          </strong>

          <small>
            Ainda não há avaliações
          </small>

        </ng-container>

      </div>

      <div
        class="avaliacao-texto"
        *ngIf="avaliacoes.length > 0"
      >

        <div
          class="avaliacao"
          *ngFor="let avaliacao of avaliacoes"
        >

          <div class="avaliacao-cabecalho">

            <strong>
              {{ avaliacao.nomeHospede }}
            </strong>

            <span class="estrelas-avaliacao">

          <ng-container
            *ngFor="let estrela of [1, 2, 3, 4, 5]"
          >

            <span
              [class.ativa]="estrela <= avaliacao.nota"
            >
              ★
            </span>

          </ng-container>

        </span>

          </div>

          <p
            *ngIf="avaliacao.comentario"
          >
            {{ avaliacao.comentario }}
          </p>

        </div>

      </div>

      <div
        class="sem-avaliacoes"
        *ngIf="avaliacoes.length === 0"
      >

        <p>
          Seja o primeiro hóspede a compartilhar
          sua experiência.
        </p>

      </div>

    </section>

    <section class="localizacao">

      <h2>
        Saiba onde você estará hospedado
      </h2>

      <div class="mapa">

        <iframe
          src="https://www.google.com/maps?q=Para%C3%ADso%20do%20Cerrado%20Goi%C3%A1s&output=embed"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

      </div>

    </section>

  </section>

</div>
